import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const CURRENCIES = [
  { code: 'KWD', label: 'Kuwaiti Dinar',   symbol: 'KD',  rate: 0.0835,  flag: '🇰🇼', decimals: 3 },
  { code: 'AED', label: 'UAE Dirham',       symbol: 'AED', rate: 1,       flag: '🇦🇪', decimals: 2 },
  { code: 'SAR', label: 'Saudi Riyal',      symbol: 'SAR', rate: 1.0209,  flag: '🇸🇦', decimals: 2 },
  { code: 'QAR', label: 'Qatari Riyal',     symbol: 'QAR', rate: 0.9911,  flag: '🇶🇦', decimals: 2 },
  { code: 'BHD', label: 'Bahraini Dinar',   symbol: 'BD',  rate: 0.1025,  flag: '🇧🇭', decimals: 3 },
  { code: 'OMR', label: 'Omani Rial',       symbol: 'OMR', rate: 0.1048,  flag: '🇴🇲', decimals: 3 },
  { code: 'USD', label: 'US Dollar',        symbol: '$',   rate: 0.2723,  flag: '🇺🇸', decimals: 2 },
];

// All prices stored in AED — rate converts from 1 AED to target currency
const COUNTRY_CURRENCY = {
  KW: 'KWD', AE: 'AED', SA: 'SAR', QA: 'QAR', BH: 'BHD', OM: 'OMR', US: 'USD',
};

export function formatPrice(aedAmount, currency) {
  const cur = currency || CURRENCIES[0]; // fallback KWD
  const val = Number(aedAmount || 0) * cur.rate;
  return `${cur.symbol} ${val.toLocaleString('en', {
    minimumFractionDigits: cur.decimals,
    maximumFractionDigits: cur.decimals,
  })}`;
}

// Sorted list: local currency first, USD last, rest in between
export function sortedCurrencies(localCode) {
  return [
    ...CURRENCIES.filter(c => c.code === localCode),
    ...CURRENCIES.filter(c => c.code !== localCode && c.code !== 'USD'),
    ...CURRENCIES.filter(c => c.code === 'USD'),
  ];
}

const useCurrencyStore = create(
  persist(
    (set, get) => ({
      currency: CURRENCIES[0], // default: KWD
      localCode: 'KWD',        // detected home currency
      manuallySet: false,

      setCurrency: (code) => {
        const match = CURRENCIES.find(c => c.code === code);
        if (match) set({ currency: match, manuallySet: true });
      },

      // Call once on app start — only auto-sets if user hasn't manually picked
      detectFromIP: async () => {
        if (get().manuallySet) return;
        try {
          const r = await fetch('https://ipapi.co/json/');
          const data = await r.json();
          const code = COUNTRY_CURRENCY[data.country_code] || 'KWD';
          const match = CURRENCIES.find(c => c.code === code);
          if (match) set({ currency: match, localCode: code });
        } catch {
          // stay on KWD
        }
      },
    }),
    { name: 'findr-currency' }
  )
);

export default useCurrencyStore;
